import { FormOption } from '../../../../../../../../types/Form';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import useFlowQuestions from '../../../../../hooks/useFlowQuestions';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import { parseStringForAnswers } from '../../../../../utils/stringUtils';
import useAvailableIndices from '../../table/hooks/useAvailableIndices';

const useEntityOptions = (targetQuestion: FlowsQuestion): FormOption[] => {
  const answers = useFlowsSelector((state) => state.flows.answers);
  const questions = useFlowQuestions();

  const availableIndices = useAvailableIndices(targetQuestion);
  const { entity_formatted_str } = targetQuestion?.rules.table || {};

  return availableIndices.map((answerIndex, arrayIndex) => ({
    value: (answerIndex || 0).toString(),
    label: entity_formatted_str
      ? parseStringForAnswers({
          answers,
          question: entity_formatted_str,
          index: answerIndex,
          toDisplayIndex: arrayIndex,
          questions,
        })
      : arrayIndex.toString(),
  }));
};

export default useEntityOptions;
